import { Controller } from 'react-hook-form'
import UserFormField from '../../User/UserFormField'
import { useFormContextRequester } from '../utils/_utils'

const Idnps = () => {
    const { control } = useFormContextRequester()

    return (
        <Controller
            control={control}
            name="nationalId"
            render={({ field, fieldState: { error } }) => (
                <UserFormField
                    variant="input"
                    label="Identifiant national"
                    locked
                    status={{
                        error,
                        valid: (field.value?.trim().length ?? 0) > 0,
                    }}
                    placeholder="Identifiant national"
                    dataCyScope="UserField"
                    {...field}
                    value={field?.value ?? ''}
                    disabled
                />
            )}
        />
    )
}

export default Idnps
